import React from 'react';
import { Button, Select, Divider } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useSimpleCondition from './useSimpleCondition';

import styles from './SimpleCondition.module.less';

const { Option } = Select;

function SimpleCondition(props) {

  const { t } = useTranslation();
  const { isLastItem, ...rest } = props;
  const {
    orCondition,
    removeOrCondition,
    onChangeOrCondition,
    alarmsFieldsLoading,
    filterFields,
    isEditDefault,
    dataType,
  } = useSimpleCondition({ ...rest });
  const { type, field, params } = orCondition;

  return (
    <>
      <div className={styles.wrapper}>
        <Button
          className={styles.remove_item}
          shape="circle"
          size="small"
          type="text"
          onClick={removeOrCondition}
          disabled={isEditDefault}
        >
          <FontAwesomeIcon icon={faMinusCircle} />
        </Button>

        <div className={styles.inputs}>

          <Select
            className={`${styles.take_two_columns}`}
            value={type}
            onSelect={(value) => onChangeOrCondition('type', value)}
            disabled={isEditDefault}
          >
            <Option value="equality">
              {t('views.dynamic_alarms_create_edit.type_alarm_options.equality')}
            </Option>
          </Select>

          <Select
            className={`${styles.take_two_columns}`}
            value={field}
            onSelect={(value) => onChangeOrCondition('field', value)}
            disabled={isEditDefault}
          >
            { dataType.map((option, index) => {

              const { name, edge_name } = option;
              return (
                <Option key={`edge_name_${edge_name}`} value={edge_name}>
                  {name}
                </Option>
              );

            })}
          </Select>

          {['numeric_threshold', 'equality'].includes(type) && (
            <>
              <Select
                loading={alarmsFieldsLoading}
                className={`${styles.take_two_columns}`}
                value={params?.values[0]}
                onSelect={(value) => onChangeOrCondition('params', value)}
                disabled={isEditDefault}
              >
                {filterFields.map((data, index) => {

                  const { name, edge_name } = data;
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <Option key={`edge_name_${index}`} value={edge_name}>
                      {name}
                    </Option>
                  );

                })}
              </Select>
            </>
          )}

        </div>
      </div>
      {!isLastItem && <Divider className={styles.divider} />}
    </>
  );

}

SimpleCondition.propTypes = {
  groupIndex: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  isLastItem: PropTypes.bool,
};

SimpleCondition.defaultProps = {
  isLastItem: false,
};

export default SimpleCondition;
